import React, { useState } from 'react';
import ProductionRunsTab from './ProductionRunsTab';
import FormulasTab from './FormulasTab';
import CostingTab from './CostingTab';

const SUB_TABS = [
  { id: 'production', label: '🏭 Production' },
  { id: 'recipes', label: '📋 Recipes' },
  { id: 'costing', label: '🧮 Costing' },
];

const ProductionTab = () => {
  const [active, setActive] = useState('production');

  return (
    <div>
      <div style={styles.subTabBar}>
        {SUB_TABS.map((t) => (
          <button
            key={t.id}
            onClick={() => setActive(t.id)}
            style={{ ...styles.subTab, ...(active === t.id ? styles.subTabActive : {}) }}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div>
        {active === 'production' && <ProductionRunsTab />}
        {active === 'recipes' && <FormulasTab />}
        {active === 'costing' && <CostingTab />}
      </div>
    </div>
  );
};

const styles = {
  subTabBar: {
    display: 'flex',
    gap: '4px',
    padding: '0 30px',
    borderBottom: '2px solid #f0f0f0',
    background: '#fef6f0',
  },
  subTab: {
    padding: '14px 22px',
    background: 'transparent',
    border: 'none',
    borderBottom: '3px solid transparent',
    marginBottom: '-2px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 600,
    color: '#7f8c8d',
  },
  subTabActive: {
    color: '#e67e22',
    borderBottom: '3px solid #e67e22',
  },
};

export default ProductionTab;